import React from "react";
import ModalWrapper from "../ModalWrapper";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import moment from "moment";
import { Box } from "@chakra-ui/react";

type Props = {
  onOpen: () => void;
  onClose: () => void;
  isOpen: boolean;
  prices?: any[];
  title?: string;
  isPublic?: boolean;
};

const GraphModal = (props: Props) => {
  const { isOpen, onClose, prices, title } = props;
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

  const amounts = prices?.map((price: any) => {
    return price.price;
  });
  const dates = prices?.map((price: any) => {
    return moment(price.createdAt).format("LLL");
  });

  const options = {
    responsive: true,
    scales: {
      // y: { ticks: { display: false } },
      x: { ticks: { display: false } },
    },
  };

  const datas = {
    labels: dates,
    datasets: [
      {
        label: "Whole Sale",
        data: amounts,
        borderColor: "rgb(127, 235, 94)",
        backgroundColor: "rgba(127, 235, 94,0.5)",
      },
    ],
  };

  return (
    <ModalWrapper
      onClose={onClose}
      isOpen={isOpen}
      title={`${title} | Graph`}
      size="xl"
    >
      <Box p="5">
        <Line options={options} data={datas} />
      </Box>
    </ModalWrapper>
  );
};

export default GraphModal;
